<div class="market-pairs" style="overflow: visible !important">
  <!-- Header -->
  <div class="custom-heading py-xl-0 py-lg-0 py-md-0 py-2 px-2 d-flex align-items-xl-center align-items-lg-center align-items-md-center align-items-sm-center align-items-xs-start flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-column justify-content-between">
    <div class="d-flex align-items-xl-center align-items-lg-center align-items-md-center align-items-sm-center align-items-xs-start flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-column">
      <div class="d-flex align-items-center">
        <div class="p-1 mx-2 text-color-theme align-self-center">
          {{ "portfolio" | translate }}
        </div>
      </div>
      <div class="d-flex align-items-center">
        <button
          [disabled]="!hasSavingsData"
          matTooltipPosition="left"
          class="p-0 m-0"
          matTooltip="{{ 'export-excel' | translate }}"
          (click)="exportAsExcel()"
          mat-icon-button
          color="primary"
        >
          <mat-icon>save_alt</mat-icon>
        </button>
      </div>
    </div>

    <div class="p-1">
      <button class="btn btn-sm btn-primary" (click)="newOrder()">
        <i class="icon ion-md-add px-1"></i>
        {{ "new-order" | translate }}
      </button>
    </div>
  </div>

  <!-- Loading Spinner -->
  <table class="d-flex justify-content-center" *ngIf="isProfileLoading">
    <div class="spinner-border text-secondary m-5" role="status">
      <span class="sr-only"></span>
    </div>
  </table>

  <!-- No Data -->
  <div
    class="row no-data m-0"
    *ngIf="!isProfileLoading && !hasSavingsData"
    style="padding: 6%; min-height: 400px"
  >
    <div class="col-md-6 mx-auto text-center">
      <img class="empty-state" src="/assets/img/noData.png" />
      <div class="col-sm-12">
        <h6>No Portfolio for this Account</h6>
      </div>
    </div>
  </div>

  <!-- Savings Grouped Goals -->
  <div
    class="tab-content p-0"
    *ngIf="!isProfileLoading && hasSavingsData"
    style="min-height: 400px; max-height: 600px; overflow-y: auto"
  >
    <ng-container *ngFor="let currencyGroup of currencyGroups">
      <ng-container *ngIf="currencyGroup.goalsGrouped?.length > 0">

        <!-- Currency Label -->
        <div class="savings-currency-label px-3 py-1" style="background: rgba(255,255,255,0.04); border-bottom: 1px solid rgba(255,255,255,0.08);">
          <small class="text-muted text-uppercase" style="letter-spacing: 1px; font-size: 10px;">{{ currencyGroup.currency }}</small>
        </div>

        <!-- Goal Groups -->
        <div
          class="savings-goal-group"
          *ngFor="let goal of currencyGroup.goalsGrouped"
          style="border-bottom: 1px solid rgba(255,255,255,0.06)"
        >
          <!-- Goal Header Row (clickable) -->
          <div
            class="goal-header d-flex align-items-center justify-content-between px-3 py-2"
            (click)="toggleGoal(currencyGroup.currency, goal.CustodianCode)"
            style="cursor: pointer; transition: background 0.2s"
            [style.background]="isExpanded(currencyGroup.currency, goal.CustodianCode) ? 'rgba(255,255,255,0.05)' : 'transparent'"
          >
            <div class="d-flex align-items-center" style="gap: 8px">
              <!-- +/- Icon -->
              <mat-icon
                style="font-size: 20px; width: 20px; height: 20px; line-height: 20px;"
                [style.color]="isExpanded(currencyGroup.currency, goal.CustodianCode) ? '#ff4643' : '#26de81'"
              >
                {{ isExpanded(currencyGroup.currency, goal.CustodianCode) ? 'remove_circle_outline' : 'add_circle_outline' }}
              </mat-icon>

              <!-- Goal Name -->
              <span class="text-color-theme" style="font-weight: 600; font-size: 13px">
                {{ translate.currentLang === 'ar' ? goal.CustodianNameA : goal.CustodianNameE }}
              </span>

              <!-- Symbol Count Badge -->
              <span style="font-size: 10px; background: rgba(255,255,255,0.1); border-radius: 10px; padding: 1px 7px; color: #aaa">
                {{ goal.Portfolio?.length }} {{ 'symbols' | translate }}
              </span>
            </div>

            <!-- Goal Summary -->
            <div class="d-flex align-items-center goal-summary" style="gap: 20px; font-size: 12px">
              <div class="text-center">
                <div class="text-muted" style="font-size: 10px">{{ 'cost-value' | translate }}</div>
                <div class="text-color-theme">{{ goal.TotalCostValue | number:'1.2-2':'en-US' }}</div>
              </div>
              <div class="text-center">
                <div class="text-muted" style="font-size: 10px">{{ 'mkt-value' | translate }}</div>
                <div class="text-color-theme">{{ goal.TotalMarketValue | number:'1.2-2':'en-US' }}</div>
              </div>
              <div class="text-center">
                <div class="text-muted" style="font-size: 10px">G/L</div>
                <div [ngClass]="goal.TotalGL > 0 ? 'green' : goal.TotalGL < 0 ? 'red' : 'text-color-theme'">
                  {{ goal.TotalGL | number:'1.2-2':'en-US' }}
                </div>
              </div>
              <div class="text-center">
                <div class="text-muted" style="font-size: 10px">G/L %</div>
                <div [ngClass]="goal.TotalGLPer > 0 ? 'green' : goal.TotalGLPer < 0 ? 'red' : 'text-color-theme'">
                  {{ goal.TotalGLPer | number:'1.2-2':'en-US' }}%
                </div>
              </div>
            </div>
          </div>

          <!-- Expanded Detail Table -->
          <div *ngIf="isExpanded(currencyGroup.currency, goal.CustodianCode)">
            <div class="table-responsive">
              <table class="table table-sm table-dark m-0" style="font-size: 12px">
                <thead style="z-index: 100">
                  <tr style="background: rgba(255,255,255,0.06)">
                    <th class="fit text-center">{{ 'symbol' | translate }}</th>
                    <th class="fit text-center" *ngFor="let col of visibleColumns">
                      {{ col.name | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of goal.Portfolio" style="height: 28px">
                    <!-- Buy/Sell -->
                    <!-- <td sticky class="fit" style="white-space: nowrap">
                      <button
                        (click)="orderBuy(item, 0); $event.stopPropagation()"
                        mat-flat-button
                        class="my-class"
                        style="background: #26de81; min-width: 26px; padding: 0 5px; font-size: 11px; line-height: 22px"
                      >B</button>
                      <button
                        (click)="orderBuy(item, 1); $event.stopPropagation()"
                        mat-flat-button
                        class="my-class"
                        style="background: #ff4643; min-width: 26px; padding: 0 5px; font-size: 11px; line-height: 22px"
                      >S</button>
                    </td> -->

                    <!-- Symbol -->
                    <td sticky class="fit text-center">
                      {{ translate.currentLang === 'en' ? item.SymbolNameEn : item.SymbolNameAr }}
                      <i
                        mat-raised-button
                        [matTooltipPosition]="translate.currentLang === 'en' ? 'before' : 'after'"
                        matTooltip="{{ 'hasOrder' | translate }}"
                        matTooltipClass="custom-tooltip tooltip-position"
                        *ngIf="item.hasOrders"
                        class="fa fa-commenting mx-2"
                        style="color: cadetblue; font-size: large"
                        [ngStyle]="translate.currentLang === 'ar' ? {transform:'scaleX(-1)'} : {transform:'scaleX(1)'}"
                      ></i>
                    </td>

                    <!-- Dynamic Columns -->
                    <td class="fit text-center" *ngFor="let col of visibleColumns" [ngSwitch]="col.prop">
                      <span *ngSwitchCase="'Qty'" [ngbTooltip]="tooltipContent" placement="left" tooltipClass="my-custom-class" triggers="hover:mouseleave">
                        {{ item.Qty | number:'1.0':'en-US' }}
                      </span>
                      <span *ngSwitchCase="'MarketValue'">{{ item.MarketValue | number:'1.2-2':'en-US' }}</span>
                      <span *ngSwitchCase="'MarginPercentage'">
                        {{ item.MarginPercentage === -1 ? (translate.instant('margin-not-available-custodian')) : item.MarginPercentage }}
                      </span>
                      <span *ngSwitchCase="'MarginMarketValue'">{{ item.MarginMarketValue | number:'1.2-2':'en-US' }}</span>
                      <span *ngSwitchCase="'CostValue'">{{ item.CostValue | number:'1.2-2':'en-US' }}</span>
                      <span [ngClass]="item.GL > 0 ? 'green' : item.GL < 0 ? 'red' : 'white'" *ngSwitchCase="'GL'">
                        {{ item.GL | number:'1.2-2':'en-US' }}
                      </span>
                      <span [ngClass]="item.GL > 0 ? 'green' : item.GL < 0 ? 'red' : 'white'" *ngSwitchCase="'GLPerc'">
                        {{ item.GLPerc }}%
                      </span>
                      <span *ngSwitchCase="'SetteledQty'">{{ item.SetteledQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'BlkSetteledQty'">{{ item.BlkSetteledQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'AvbSetteledQty'">{{ item.AvbSetteledQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'TPlusZeroQty'">{{ item.TPlusZeroQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'BlkTPlusZeroQty'">{{ item.BlkTPlusZeroQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'AvbTPlusZeroQty'">{{ item.AvbTPlusZeroQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'TPlusOneQty'">{{ item.TPlusOneQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'BlkTPlusOneQty'">{{ item.BlkTPlusOneQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'AvbTPlusOneQty'">{{ item.AvbTPlusOneQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'NormalQty'">{{ item.NormalQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'TPlusThreeQty'">{{ item.TPlusThreeQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'TPlusFourQty'">{{ item.TPlusFourQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchCase="'TPlusFiveQty'">{{ item.TPlusFiveQty | number:'1.0':'en-US' }}</span>
                      <span *ngSwitchDefault>{{ item[col.prop] }}</span>
                    </td>

                    <!-- Qty Breakdown Tooltip -->
                    <ng-template #tooltipContent>
                      <div class="table-wrapper">
                        <table class="table table-sm table-borderless">
                          <thead>
                            <tr>
                              <th></th>
                              <th class="fit">{{ 'norm' | translate }}</th>
                              <th class="fit">{{ 'blk' | translate }}</th>
                              <th class="fit">{{ 'avb' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="fit">{{ 'setteled' | translate }}</td>
                              <td>{{ item?.SetteledQty | number }}</td>
                              <td>{{ item?.BlkSetteledQty | number }}</td>
                              <td>{{ item?.AvbSetteledQty | number }}</td>
                            </tr>
                            <tr>
                              <td class="fit">{{ 't0' | translate }}</td>
                              <td>{{ item?.TPlusZeroQty | number }}</td>
                              <td>{{ item?.BlkTPlusZeroQty | number }}</td>
                              <td>{{ item?.AvbTPlusZeroQty | number }}</td>
                            </tr>
                            <tr>
                              <td class="fit">{{ 't1' | translate }}</td>
                              <td>{{ item?.TPlusOneQty | number }}</td>
                              <td>{{ item?.BlkTPlusOneQty | number }}</td>
                              <td>{{ item?.AvbTPlusOneQty | number }}</td>
                            </tr>
                            <tr>
                              <td class="fit">{{ 'un-setteled' | translate }}</td>
                              <td>{{ item?.NormalQty | number }}</td>
                              <td>-</td>
                              <td>-</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- /Expanded Detail -->
        </div>
        <!-- /Goal Group -->

      </ng-container>
    </ng-container>
  </div>
</div>
<ngx-loading
  [show]="isRequestLoading"
  [config]="{ backdropBorderRadius: '3px' }"
></ngx-loading>
